export const sortQueryData = queryData => {
  return [...queryData["images"]["edges"]].sort((a, b) =>
    a.node.name > b.node.name ? 1 : b.node.name > a.node.name ? -1 : 0
  )
}
